import { render, staticRenderFns } from "./ShipmentDetailDialog.vue?vue&type=template&id=60a8497e"
import script from "./ShipmentDetailDialog.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports